import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAuthUser } from "../../helpers/utils";
import DeleteModal from "../../Components/Common/DeleteModal";
import CommonTable from "../../Components/Common/Table/CommonTable";
import AddModal from "../../Components/Common/Modal/AddModal"; 
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { toast } from "react-toastify";
import { fetchAllTopics, fetchExaminationBoard, fetchGrade } from "../../slices/topics/thunk"; 
import {
  addSubTopic,
  deleteSubTopic,
  activateDeactivateSubTopic,
  updateSubTopic, 
  uploadSubTopicImageIcon,
  fetchTopics,
} from "../../slices/subTopic/thunk";
import ColumnSelectionModal from "../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import { fetchAllSubTopics, fetchSubTopicTableColumnNames, fetchTranslation, updateUserPreference } from "../../slices/thunks"; // Removed fetchCountry as it's not used here
import AddSubTopicsModalForm from "../../Components/Common/AddTopicsModalForm/AddSubTopicsModalForm";
import { set } from "lodash";
import CommonAddModal from "../../Components/Common/Modal/CommonAddModal";
import { ErrorMessage } from "formik";
import CommonDataTable from "../../Components/Common/Table/CommonDataTable";
import usePermissions from "../../Components/Hooks/usePermissions";

const labels = [

  {
    id: 1,
    labelName: "Sub Topic Name English",
    fieldName: "text-box-translate",
    name: "SubTopicNameEn",
    value: "SubTopicNameEn", 
    required: true,
    translateTo:"SubTopicNameAr",
    errorMessage: "Please Enter Sub Topic Name in English",
  },
  {
    id: 2,
    labelName: "Sub Topic Name Arabic",
    fieldName: "text-box",
    name: "SubTopicNameAr", 
    value: "SubTopicNameAr",
    required: true,
    errorMessage: "Please Enter Sub Topic Name in Arabic",
  },
  {
    id: 3,
    labelName: "Topics",
    fieldName: "topic-drop-down",
    name: "TopicID",
    value: "TopicID", 
    required: true,
    errorMessage: "Please Select Topic",
  },
  {
    id: 4,
    labelName: "Sub Topic Icon",
    fieldName: "file",
    name: "ImageURL",
    value: "ImageURL",
    required: true,
  },
];

const actionConfig = {
  edit: {
    icon: "ri-edit-2-line",
    tooltip: "Edit",
  },
  delete: {
    icon: "ri-delete-bin-2-line",
    tooltip: "Delete",
  },
};

function SubTopicMasterTable() { 
  const dispatch = useDispatch();
  const { user } = getAuthUser();
  const { t, i18n } = useTranslation();
  
  const [show, setShow] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedFiles, setselectedFiles] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [lastTranslatedField, setLastTranslatedField] = useState(null);


  

  const { subTopics, loading, headerload, error, tableColumnNames, module, uploadedImageUrl, translationLoading } = useSelector((state) => ({
    subTopics: state.SubTopics.subTopics, 
    loading: state.SubTopics.loading,
    headerload: state.SubTopics.headerload,
    error: state.SubTopics.error,
    tableColumnNames: state.SubTopics.tableColumnNames,
    uploadedImageUrl: state.SubTopics.uploadedImageUrl,
    module: state.Module.module, 
    translationLoading: state.Module.translationLoading, 
  }));


    // Compute permission
  const permission = (() => {
    return usePermissions(3, 12);
  })();

  useEffect(() => {
    dispatch(fetchSubTopicTableColumnNames({ module: "SUBTOPICS" })); 
    dispatch(fetchAllSubTopics());
    dispatch(fetchAllTopics({IsActive:true}));
  }, [dispatch, user.UserId]);

  const onChangeHandler = (e) => {
    setSelectedRow((preValue) => ({
      ...preValue,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClassesClicks = (value) => {
    setShow(true);
    setIsDisabled(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (topic, value) => {
      setSelectedRow(topic);
      setIsDisabled(false);
      setIsAddOrEdit(value);
      setShow(true);
  }

   const onTranslateClickHandler = (targetField, textToTranslate, formikSetFieldValue, sourceFieldName) => {
      if (!textToTranslate || textToTranslate.trim() === "") {
        toast.error(t("EnterTextToTranslate"));
        return;
      }
      setLastTranslatedField(sourceFieldName); 
  
      dispatch(fetchTranslation({ LangText: textToTranslate }))
        .unwrap() 
        .then(translatedText => {
          formikSetFieldValue(targetField, translatedText);
        })
        .catch(error => {
          console.error("Translation error:", error);
          toast.error(t("TranslationFailed"));
        })
        .finally(() => {
          setLastTranslatedField(null); 
        });
    };


  // Handler for single delete confirmation
  const handleConfirmSingleDelete = () => {

      dispatch(deleteSubTopic({ SubTopicsIDs: selectedIds})).unwrap()
        .then(() => {
          setDeleteModal(null);
        })
    setDeleteModal(false);
  };

   const onSubmitHandler = async (values, { resetForm, setSubmitting }) => {
      setIsDisabled(true); 
  
      try {
        const finalImageUrl = values.ImageURL; 
  
        if (!finalImageUrl && labels.find(l => l.name === "ImageURL" && l.required)) {
            toast.error(t("PleaseUploadSubTopicIcon"));
            setIsDisabled(false);
            setSubmitting(false);
            return;
        }
        
        const payload = {
          SubTopicNameEn: values.SubTopicNameEn,
          SubTopicNameAr: values.SubTopicNameAr,
          ImageURL: finalImageUrl, 
          TopicID: values.TopicID, 
        };
  
        if (isAddOrEdit === 'isEdit') {
          payload.ID = selectedRow.ID;
          dispatch(updateSubTopic(payload))
        } else {
          dispatch(addSubTopic(payload))
        }
        
        setShow(false); 
        resetForm();    
      } catch (error) {
        console.error("Topic submission error:", error);
      } finally {
        setIsDisabled(false);
        setSubmitting(false); 
      }
    };

  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchSubTopicTableColumnNames({module: "SUBTOPICS"})
      );

      setModalOpen(false);
    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };


  const handleImageUpload = (files) => {
    setIsDisabled(true);
    const processedFiles = files.map(file =>
        Object.assign(file, {
            preview: URL.createObjectURL(file),
            formattedSize: formatBytes(file.size),
        })
    );
    setselectedFiles(processedFiles);
    processedFiles.forEach(file => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const imageDataUrl = reader.result;
            const base64Image = imageDataUrl.split(',')[1];
            dispatch(uploadSubTopicImageIcon({ ImageData: base64Image, folderName: 'SubTopics' })); // Changed to uploadSubTopicImageIcon
        };
        reader.readAsDataURL(file);
    });
  };

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }


  const onActiveOrDeactiveChange = (topic, e) => {
    if (!permission.CanEdit) {
      toast.error(t("NoPermissionToEdit"));
      return;
    }
      const subTopicObj = {}; 
      subTopicObj['ID'] = topic.ID;
      subTopicObj['IsActive'] = !topic.IsActive;
      subTopicObj['TableName'] = 'SubTopics';
      dispatch(activateDeactivateSubTopic(subTopicObj)); 
  }

  const onDeleteClickHandler = topic => {
    if (!permission.CanDelete) {
      toast.error(t("NoPermissionToDelete"));
      return;
    }
    setSelectedIds([topic.ID]);
    setDeleteModal(true);
  }


  return (
    <React.Fragment>
    
      <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("Sub Topics")} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
                <Row className="g-4">
                    <Col className="col-sm-auto">
                      <div>
                        <Button
                          className="btn btn-soft-danger ms-2 me-2"
                          onClick={() => setDeleteModal(true)}
                          disabled={selectedIds.length === 0}
                        >
                          <i className="ri-delete-bin-2-line"></i>
                        </Button>
                        {permission.CanAdd && (
                          <Button
                            color="secondary"
                            className="add-btn me-1"
                            onClick={() => handleClassesClicks("isAdd")}
                            id="create-btn"
                            disabled={loading}
                          >
                            <i className="ri-add-line align-bottom me-1 ms-1"></i>
                            {t("AddNew")}
                          </Button>
                        )}
                      </div>
                    </Col>
                    <Col className="col-sm">
                      <div className="d-flex justify-content-sm-end">
                        <Button
                          className="btn btn-soft"
                          onClick={() => setModalOpen(true)}
                          disabled={loading}
                        >
                          <i className="ri-filter-3-line"></i>
                        </Button>
                        <div className="search-box ms-2 me-2">
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={t("Search")}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      </div>
                    </Col>
                  </Row>
            </CardHeader>
            <CardBody>
              {loading || headerload? (
                <div className="d-flex justify-content-center align-items-center">
                <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                  Loading...
                </Spinner>
                </div>
              ) : (
                <div className="listjs-table" id="customerList">
                  {/* <CommonTable
                    data={subTopics || []} // Corrected to use subTopics
                    tableColumnNames={tableColumnNames || []}
                    searchTerm={searchTerm}
                    onEditClickHandler={onEditClickHandler}
                    onDeleteClick={onDeleteClickHandler}
                    onActiveOrDeactiveChange={onActiveOrDeactiveChange} 
                    setDeleteModal={setDeleteModal}
                    setSelectedIds={setSelectedIds}
                    permission={permission}
                    keyField="ID"
                  /> */}
                   <CommonDataTable
                      data={subTopics || []}
                      tableColumnNames={tableColumnNames || []}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      actionConfig={actionConfig}
                      permission={permission}
                    />
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </Container>  
      </div>      

        {/* Add/Edit Modal  */}
        {/* <AddModal
          show={show}
          setShow={setShow}
          isDisabled={isDisabled}
          onSubmitHandler={onSubmitHandler}
          title={
            isAddOrEdit === "isAdd" ? t("Add New Sub Topic") : t("Edit Sub Topic") 
          }
          modalBody={
            <AddSubTopicsModalForm
              labels={labels}
              onChangeHandler={onChangeHandler}
              isAddOrEdit={isAddOrEdit}
              setSelectedRow={setSelectedRow}
              selectedRow={selectedRow}
              handleImageUpload={handleImageUpload}
              selectedFiles={selectedFiles}
            />
          }
        /> */}
         <CommonAddModal
            show={show}
            setShow={setShow}
            onSubmitHandler={onSubmitHandler}
            labels={labels}
            isAddOrEdit={isAddOrEdit}
            selectedItemData={selectedRow} 
            FormBody={AddSubTopicsModalForm}
            FormBodyProps={{ 
              onTranslateClickHandler, 
              translationLoading,
              lastTranslatedField,
              setParentSubmitDisabled: setIsDisabled, 
            }}
            title={isAddOrEdit === "isAdd" ? t("Add New Sub Topic") : t("Edit Sub Topic")}
            size="lg" 
            isDisabled={isDisabled} 
         />

        {/* Single Delete Confirmation Modal  */}
        <DeleteModal
          showDelete={deleteModal}
          setShowDelete={setDeleteModal}
          onDeleteClick={handleConfirmSingleDelete}
          setSelectedIds={setSelectedIds}
          description={"Are you sure you want to delete this record?"}      
        />

        {/* ColumnSelectionModal */}
        <ColumnSelectionModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(!modalOpen)}
          columns={tableColumnNames}
          selectedColumns={selectedColumns}
          setSelectedColumns={setSelectedColumns}
          handleSave={handleSave}
        />

    </React.Fragment>
  );
}

export default SubTopicMasterTable;
